import { render, staticRenderFns } from "./SectionLoStudio.vue?vue&type=template&id=31ab5fd5&scoped=true&"
import script from "./SectionLoStudio.vue?vue&type=script&lang=js&"
export * from "./SectionLoStudio.vue?vue&type=script&lang=js&"
import style0 from "./SectionLoStudio.vue?vue&type=style&index=0&id=31ab5fd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab5fd5",
  null
  
)

export default component.exports